module.exports = __webpack_public_path__ + "img/xp_bar_basic.b535a691.svg";